import styled from 'styled-components';
import { MediaBreakPointUp } from "../../../../theme";
export var StyledOrderPreview = styled.div.withConfig({
  displayName: "StyledOrderPreview",
  componentId: "sc-133h95-0"
})(["display:flex;flex-direction:column;align-items:flex-start;margin:68px auto 0 auto;padding:20px;width:435px;max-width:435px;border:0.5px solid #e7e2ff;border-radius:20px;background:#fff;@media screen and (max-width:", "){width:calc(100% - 30px);box-sizing:border-box;margin:20px auto 15px;max-width:auto;}"], MediaBreakPointUp.sm);
export var StyledHeader = styled.div.withConfig({
  displayName: "StyledHeader",
  componentId: "sc-133h95-1"
})(["display:flex;align-items:center;"]);
export var BackButton = styled.button.withConfig({
  displayName: "BackButton",
  componentId: "sc-133h95-2"
})(["background:transparent;padding:0;border:none;cursor:pointer;outline:none;margin-right:16px;"]);
export var Title = styled.div.withConfig({
  displayName: "Title",
  componentId: "sc-133h95-3"
})(["color:#000;font-size:24px;font-weight:600;line-height:150%;"]);
export var Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-133h95-4"
})(["display:flex;flex-direction:column;justify-content:space-between;width:100%;height:100%;margin-top:24px;"]);
export var StyledLabel = styled.div.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-133h95-5"
})(["color:#2c2842;font-size:12px;font-weight:400;line-height:16px;"]);
export var StyledMainContent = styled.div.withConfig({
  displayName: "StyledMainContent",
  componentId: "sc-133h95-6"
})(["display:flex;flex-flow:column nowrap;gap:24px;margin-bottom:24px;p{margin-bottom:0;}"]);
export var StyledTokenPairWrapper = styled.div.withConfig({
  displayName: "StyledTokenPairWrapper",
  componentId: "sc-133h95-7"
})(["padding-bottom:24px;border-bottom:0.5px dashed #8d93b5;.arrow-icon{margin:12px 0;}"]);
export var TokenRow = styled.div.withConfig({
  displayName: "TokenRow",
  componentId: "sc-133h95-8"
})(["display:flex;align-items:center;flex-direction:row;gap:8px;margin:8px 0 0;width:100%;"]);
export var StyledTokenSymbol = styled.span.withConfig({
  displayName: "StyledTokenSymbol",
  componentId: "sc-133h95-9"
})(["color:#5f4dbc;font-size:20px;font-weight:600;line-height:24px;"]);
export var StyledText = styled.div.withConfig({
  displayName: "StyledText",
  componentId: "sc-133h95-10"
})(["display:flex;flex-flow:row nowrap;align-items:center;color:#5a5d6d;font-size:14px;font-weight:400;line-height:24px;span{white-space:pre;}.highLight{color:#5f4dbc;font-size:20px;font-weight:600;line-height:24px;}"]);
export var StyledButtons = styled.div.withConfig({
  displayName: "StyledButtons",
  componentId: "sc-133h95-11"
})(["display:flex;flex-flow:column nowrap;align-items:center;gap:16px;margin-top:16px;"]);
export var StyledAdjustButton = styled.button.withConfig({
  displayName: "StyledAdjustButton",
  componentId: "sc-133h95-12"
})(["display:flex;justify-content:center;align-items:center;background:#fff;border-radius:48px;border:1px solid #604dbc;color:#705fc0;font-size:16px;font-weight:500;line-height:140%;outline:none;padding:13px 0;text-align:center;width:100%;cursor:pointer;"]);